import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import CardMedia from '@material-ui/core/CardMedia'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import InputAdornment from '@material-ui/core/InputAdornment'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import { connect } from 'react-redux'

import { isEmail } from '../../Commons/utils'
import { LOGIN } from './auth.actions'
import TextField from '../../Components/TextField.component'

export class LoginContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      password: '',
      showPassword: false,
    }
  }

  onChangeText = attr => event => {
    event.persist()
    this.setState(() => ({
      [attr]: event.target.value
    }))
  }

  onSubmit = event => {
    event.preventDefault()
    const { email, password } = this.state
    const { Auth } = this.props

    if (isEmail(email) && password.trim().length >= 6) {
      Auth(email, password)
    }
  }

  showPassword = () => this.setState(state => ({ showPassword: !state.showPassword }))
  handleMouseDownPassword = event => event.preventDefault()

  render = () => {
    const {
      email,
      password,
      showPassword,
    } = this.state
    const {
      classes,
      Login,
    } = this.props

    return (
      <div className={classes.root}>
        <Grid
          className={classes.container}
          container
          alignContent='center'
          justify='center'
          alignItems='center'
        >
          <Grid
            className={classes.contentForm}
            item
            xs={12}
            md={4}
          >
            <Paper>
              <Grid
                container
                direction='column'
                justify='center'
                alignItems='center'
              >
                <CardMedia
                  component='img'
                  image='https://yu-track.com/wp-content/uploads/2018/11/logo-yutrack-enterprise.svg'
                  className={classes.logo}
                />
                <Typography variant='subtitle1'>
                  {'INICIAR SESIÓN'}
                </Typography>
                <form onSubmit={this.onSubmit} className={classes.form}>
                  <TextField
                    className={classes.textField}
                    variant='outlined'
                    label='Email'
                    margin='normal'
                    value={email}
                    type='email'
                    onChange={this.onChangeText('email')}
                    error={(email.trim().length > 0 && !isEmail(email))
                      || Boolean(Login.error)}
                  />
                  <TextField
                    className={classes.textField}
                    id='outlined-adornment-password'
                    variant='outlined'
                    type={showPassword ? 'text' : 'password'}
                    label='Contraseña'
                    value={password}
                    onChange={this.onChangeText('password')}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            edge='end'
                            aria-label='toggle password visibility'
                            onClick={this.showPassword}
                            onMouseDown={this.handleMouseDownPassword}
                            className={classes.visibilityButton}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    error={Boolean(Login.error)}
                    helperText={Login.error ? Login.error : null}
                  />
                  <div>
                    <Button
                      variant='contained'
                      type='submit'
                      className={classes.button}
                      color='secondary'
                      disabled={Login.loading}
                    >
                      {'INGRESAR'}
                      {Login.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </Button>
                  </div>
                </form>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = ({ Login }) => ({ Login })

const mapDispatchToProps = dispatch => ({
  Auth: (email, password) => dispatch(LOGIN({ email, password })),
})

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  container: {
    backgroundColor: '#f5f5f5',
    height: '100%',
    width: '100%',
  },
  contentForm: {
    boxSizing: 'border-box',
    padding: 25,
  },
  logo: {
    width: 120,
    objectFit: 'contain',
    margin: '25px 25px 20px'
  },
  textField: {
    width: '100%',
    marginBottom: 20,
  },
  title: {
    color: '#474361',
    textTransform: 'uppercase',
    fontWeight: '300',
    fontSize: '1rem',
    letterSpacing: '0.3rem',
  },
  button: {
    width: '100%',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  visibilityButton: {
    marginLeft: -6,
    marginRight: -10,
  },
  form: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 25px 25px',
  },
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(LoginContainer)
